import { createSlice } from '@reduxjs/toolkit';


export const classDimensionsBtn = createSlice({
  name: 'classDimensionsBtn',
  initialState: {
    ClassDimensionsButton: ''
  },
  reducers: {
    setClassDimensionsButton: (state, action) => {
      return action.payload;
    }
  },
  extraReducers: {
    // Extra reducer comes here
  }
});

export const { setClassDimensionsButton } = classDimensionsBtn.actions;
